module.exports = __webpack_public_path__ + "img/discount-banner.337b07e.png";